(function ($) { //legacy js function
    'use strict';

  function exitLinkNotificaton() {
    var path = '/footer/policies#linking',
        altText = 'Exit Disclaimer',
        lang = $('meta[name="content-language"]').attr('content'),
      exitIcon = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox = "0 0 72 72" enable-background="new 0 0 72 72" xml:space="preserve" alt="' + altText + '"  width="20px" height="16px"><path fill="#00538f" d="M54.7,52.6c0,2.3-1.9,4.1-4.1,4.1H13.2c-2.3,0-4.1-1.9-4.1-4.1V27.7c0-2.3,1.9-4.1,4.1-4.1h24.9l4.1-4.1h-29 c-4.6,0-8.3,3.7-8.3,8.3v24.9c0,4.6,3.7,8.3,8.3,8.3h37.3c4.6,0,8.3-3.7,8.3-8.3V36l-4.1,4.1V52.6z M42.2,11.1l8.3,8.3L33.9,36 l8.3,8.3l16.6-16.6l8.3,8.3V11.1H42.2z"/></svg>';

    if (!path) {
      if (lang == "en") {
        path = $('meta[name="english-linking-policy"]').attr('content');
        altText = 'Exit Disclaimer';
      }
      else {
        path = $('meta[name="english-linking-policy"]').attr('content');
        altText = 'Exit Disclaimer';
      }
    }

    $("a").filter(function () {
      return /^https?\:\/\/([a-zA-Z0-9\-]+\.)+/.test(this.href) && !/^https?\:\/\/([a-zA-Z0-9\-]+\.)+gov/.test(this.href) && this.href != "" && !$(this).children("img").length > 0 && this.href.indexOf(location.protocol + "//" + location.hostname) != 0 && !($(this).hasClass("no-exit-notification") || $(this).hasClass("noexit"))
      }).after('&nbsp;<a class="exitNotification" href=' + path + '>' + exitIcon + '</a>');
  };

  window.exitLinkNotificaton = exitLinkNotificaton;
}(jQuery));
